var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"github-auth-button",attrs:{"type":"button"},on:{"click":_vm.handleClick}},[_c('img',{staticClass:"github-icon",attrs:{"src":require('@/assets/svg/github.svg'),"alt":"GitHub"}}),_c('span',{staticClass:"github-button-text"},[_vm._v("Continue with GitHub")])])
}
var staticRenderFns = []

export { render, staticRenderFns }